/* eslint new-cap: 0 */
/* global PSSessions, analyticsIntegrations */
import React from 'react';
import ReactDOM from 'react-dom';
import { Modal } from '../elements-modal/modal';
import withSearchSubmitHoc from '../elements-search-module/search-submit-hoc';
import { SearchFormNav } from './SearchFormNav';
import { injectIntl } from 'react-intl';

const SearchFormNavSubmit = withSearchSubmitHoc(SearchFormNav);


class SearchModal extends React.Component {
  static updateHash () {
    window.location.hash = '';
  }

  static openSearchModal (location = null, activity = null, targetElementId = 'modal-container') {
    ReactDOM.render(
      <SearchModal
        location={ location }
        activity={ activity }
      />, document.getElementById(targetElementId));
  }

  componentDidMount () {
    analyticsIntegrations.whichModalOpened('Search Modal');
  }

  componentWillUnmount () {
    SearchModal.updateHash();
  }

  closeBehavior () {
    $('#modal-container').modal('hide');
    return ReactDOM.unmountComponentAtNode(document.getElementById('modal-container'));
  }

  locationModalBody () {
    return withSearchSubmitHoc(SearchFormNav)
  }

  render () {
    return (
      <Modal
        show
        addCloseIcon
        modalType="standard"
        modalID="search-modal"
        modalSize="sm-size"
        body={ this.props.body || <SearchFormNavSubmit /> }
        header={ this.props.header || this.props.intl.formatMessage({ id: 'boards.search_modal.find_space', defaultMessage: 'Find a Space' }) }
        subheader={ this.props.subheader || null }
        footer={null}
        closeBehavior={this.closeBehavior}
        targetElementId={ this.props.targetElementId }
        filter={ this.props.filter }
        modalType={ this.props.modalType }
      />
      );
  }
}

exports.SearchModal = injectIntl(SearchModal);
